const initialState = {
  showing: false,
  group_id: null,
  state: null,
  isPreview: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_PICTURE_IN_PICTURE':
      return {...state, showing: true, media: {...action.media}, content: {...action.content}, deviceId: action.deviceId, time: action.time, isPreview: action.isPreview};
    case 'CLEAR_PICTURE_IN_PICTURE':
      return {...initialState};
    default:
      return state;
  }
};
